import React, { FC, ReactNode } from 'react';
import { ScheduledEventForm } from '../models/ScheduledEventDto';
import { UseFormReturn } from 'react-hook-form';
import { SingleRelaySwitchEvent } from './SingleRelaySwitchEvent';
import { RelaySwitchEvent } from './RelaySwitchEvent';
import { AutoRelaySwitchEvent } from './AutoRelaySwitchEvent';
import { TasmotaEvent } from './TasmotaEvent';
import { ScheduleEventDeviceConfigType } from '@thingslog/repositories';
import { ScheduledRelayCommand } from './ScheduledRelayCommand';
import { ModbusEvent } from './ModbusEvent';
import { ScheduledRelay4Command } from './ScheduledRelay4Command';

export const EventConfig: FC<EventConfigProps> = ({
  selectedEventType,
  form,
}: EventConfigProps) => {
  const renderEventConfigFields = (eventType: ScheduleEventDeviceConfigType): ReactNode => {
    switch (eventType) {
      case 'SINGLE_RELAY_SWITCH':
        return <SingleRelaySwitchEvent form={form} />;
      case 'RELAY_SWITCH':
        return <RelaySwitchEvent form={form} />;
      case 'AUTO_RELAY_SWITCH':
        return <AutoRelaySwitchEvent form={form} />;
      case 'SEND_DATE_OVER_MQTT':
        return <></>;
      case 'MODBUS_READ_REGISTER':
      case 'MODBUS_WRITE_COIL':
      case 'MODBUS_READ_COIL':
        return <ModbusEvent form={form} />;
      case 'TASMOTA_POWER':
        return <TasmotaEvent form={form} />;
      case 'SCHEDULED_RELAY_COMMAND':
        return <ScheduledRelayCommand form={form} />;
      case 'SCHEDULED_RELAY_COMMAND_4':
        return <ScheduledRelay4Command form={form} />;
      default:
        return null;
    }
  };
  return <>{renderEventConfigFields(selectedEventType)}</>;
};

interface EventConfigProps {
  selectedEventType: ScheduleEventDeviceConfigType;
  form: UseFormReturn<ScheduledEventForm, unknown, undefined>;
}
